import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  contentDetails,
  getCourseDetails,
  updateUserPorgress,
} from "ServerAPI/serverAPI";
import { useCookies } from "react-cookie";
import CourseSideBar from "../components/CourseSideBar";
import CourseContent from "../components/CourseContent";
import CommentHandler from "../components/CommentHandler";

export const CourseResume = () => {
  const [bigloading, setBigLoading] = useState(false);
  const location = useLocation();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [activeContent, setActiveContent] = useState({});
  const [courseDetails, setCourseDetails] = useState({});
  const [comments, setComments] = useState([]);
  const { courseId, sectionId } = useParams();
  const [contentId, setContentId] = useState("");
  const [cookies, setCookies] = useCookies();
  const [quizStatus, setQuizStatus] = useState("");
  const [quizStartedAt, setQuizStartedAt] = useState(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const videoProgress = useRef(0);
  const navigate = useNavigate();

  const fetchCourseDetails = async (courseId, showBigLoading = true) => {
    try {
      if (showBigLoading) {
        setBigLoading(true);
      }

      const userId = cookies.userId;
      const response = await getCourseDetails(courseId, userId);
      setCourseDetails(response.data);

      const sortedSections = response?.data?.sections?.toSorted(
        (a, b) => a.sectionNumber - b.sectionNumber
      );
      const isRetakeQuiz = location?.state?.retakeQuiz;
      if (!isRetakeQuiz) {
        sortedSections?.forEach((section) => {
          section?.courseContent.sort(
            (a, b) => a.contentNumber - b.contentNumber
          );
        });

        let firstSectionToRender = 0;
        let firstContentToRender = 0;
        let falseContentFound = false;

        for (let i = 0; i < sortedSections.length; i++) {
          for (let j = 0; j < sortedSections[i].courseContent.length; j++) {
            if (sortedSections[i].courseContent[j].completed === false) {
              firstSectionToRender = i;
              firstContentToRender = j;
              falseContentFound = true;
              break;
            }
          }
          if (falseContentFound) {
            break;
          }
        }

        if (!activeContent || Object.keys(activeContent).length <= 0) {
          const targetContent =
            sortedSections[firstSectionToRender]?.courseContent[
              firstContentToRender
            ];
          if (targetContent) {
            navigate(
              `/view-course/${courseId}/${sortedSections[firstSectionToRender]?.sectionId}/${targetContent.contentId}`
            );
            setActiveContent(targetContent);
          }
        }
      } else {
      }
      setComments(response.data.comments);
    } catch (error) {
    } finally {
      setBigLoading(false);
    }
  };

  const getActiveContent = (content) => {
    setActiveContent(content);
    setContentId(content.contentId);
  };

  useEffect(() => {
    setLoading(true);
    fetchCourseDetails(courseId);
    setLoading(false);
  }, []);

  const fetchContent = async () => {
    // if (activeContent?.contentType === "video") {
    fetchCourseDetails(courseId, false);
    // }
  };

  useEffect(() => {
    fetchContent();
  }, [params.contentId]);

  const lastContentId = useRef(null);

  useEffect(() => {
    if (activeContent?.contentType === "quiz" || activeContent?.contentType === "quizSubjective") {
      setQuizStatus("readyForQuiz");
      
      // Initialize quizStartedAt from backend data if available
      const existingStartTime = activeContent.quizResults?.quizStartedAt || activeContent.quizStartedAt;
      if (existingStartTime) {
        setQuizStartedAt(existingStartTime);
      } else if (!quizStartedAt) {
        // Only reset if we don't already have a start time for this session
        setQuizStartedAt(null);
      }
    }

    // Capture current ID to compare in cleanup
    lastContentId.current = activeContent.contentId;

    return () => {
      // ONLY reset if we are actually navigating away from this specific content piece
      // This prevents the navbar from flickering and quizStartedAt from being lost during updates
      if (lastContentId.current !== activeContent.contentId) {
        setQuizStatus("");
        setQuizStartedAt(null);
      }
    };
  }, [activeContent.contentId]); // Simplified dependency to contentId specifically

  // Capture quiz start time when status transitions to "start"
  useEffect(() => {
    if (quizStatus === "start" && !quizStartedAt) {
      const startTime = new Date().toISOString();
      console.log("CourseResume: Quiz started, capturing startTime:", startTime);
      setQuizStartedAt(startTime);
    }
  }, [quizStatus]); // Only watch quizStatus transition to 'start'
  const overlayStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
  };

  const SpinnerBig = () => {
    return (
      <>
        <style>
          {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        `}
        </style>
        <div style={overlayStyle}>
          <div
            style={{
              animation: "spin 1s linear infinite",
              borderRadius: "50%",
              height: "10rem",
              width: "10rem",
              borderTop: "2px solid #224b99",
              borderBottom: "2px solid #224b99",
            }}
          ></div>
        </div>
      </>
    );
  };

  if (bigloading) {
    return <SpinnerBig />;
  }
console.log("CourseResume: quizStatus value is:", quizStatus);
console.log("CourseResume: isQuizInProgress value being sent is:", quizStatus === "start");

  return (
    <Fragment>
      <main>
        <CourseContent
          activeContent={activeContent}
          setActiveContent={setActiveContent}
          courseDetails={courseDetails}
          comments={comments}
          videoProgress={videoProgress}
          quizStatus={quizStatus}
          setQuizStatus={setQuizStatus}
          quizStartedAt={quizStartedAt}
          setQuizStartedAt={setQuizStartedAt}
          videoDuration={videoDuration}
          setVideoDuration={setVideoDuration}
        />
        {quizStatus !== "readyForQuiz" ? (
          <>
            <CommentHandler commentData={comments} />
          </>
        ) : null}

        <CourseSideBar
          getActiveContent={getActiveContent}
          courseDetails={courseDetails}
          activeContent={activeContent}
          isQuizInProgress={quizStatus === "start"}
        />
      </main>
    </Fragment>
  );
};

export default CourseResume;
